import script from "./PublicProfileModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublicProfileModal.vue?vue&type=script&setup=true&lang=ts"

import "./PublicProfileModal.vue?vue&type=style&index=0&id=6e85a542&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e85a542"]])

export default __exports__